export const serviceChapterToggle = () => {
  const DURATION = 500;
  const buttons = document.querySelectorAll(".js-button-service-chapter");

  buttons.forEach((button) => {
    const lower = button.closest(".c-service-chapter__lower");
    if (!lower) return;

    const list = lower.querySelector(".c-service-chapter__list");
    if (!list) return;

    const items = list.querySelectorAll(":scope > .c-service-chapter__item");

    // 実例が1件以下ならボタンを非表示
    if (items.length <= 1) {
      button.closest(".c-service-chapter__button").style.display = "none";
      return;
    }

    let isExpanded = false;

    // 初期状態: 1件目の高さだけ表示
    const collapsedHeight = items[0].getBoundingClientRect().height;
    list.style.height = `${collapsedHeight}px`;
    list.style.overflow = "hidden";
    list.style.transition = `height ${DURATION}ms ease`;

    button.setAttribute("aria-expanded", "false");

    const img = button.querySelector(".-img");
    if (img) {
      img.style.transition = `transform ${DURATION}ms ease`;
    }

    button.addEventListener("click", () => {
      if (isExpanded) {
        // 閉じる: auto → 明示的な高さ → 1件目の高さ
        list.style.height = `${list.scrollHeight}px`;
        list.offsetHeight; // reflow
        list.style.height = `${items[0].getBoundingClientRect().height}px`;
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-label", "もっと実例を見る");
        if (img) img.style.transform = "";
        isExpanded = false;
      } else {
        // 開く: 現在の高さ → 全体の高さ
        list.style.height = `${list.scrollHeight}px`;
        button.setAttribute("aria-expanded", "true");
        button.setAttribute("aria-label", "実例を閉じる");
        if (img) img.style.transform = "scaleY(-1)";
        isExpanded = true;
      }
    });

    list.addEventListener("transitionend", (e) => {
      if (e.propertyName === "height" && isExpanded) {
        list.style.height = "auto";
      }
    });
  });
};
